import {
  CircularProgress,
  DialogContent,
  Stack,
  Typography
} from "@mui/material";
import { DialogRoot } from "@qubit/autoparts";
import { useTranslation } from "react-i18next";

type PreparingWorkstationModalProps = {
  isOpen: boolean;
};

export function PreparingWorkstationModal({
  isOpen
}: PreparingWorkstationModalProps) {
  const { t } = useTranslation();

  return (
    <DialogRoot open={isOpen} maxWidth="sm" disableEscapeKeyDown>
      <DialogContent>
        <Stack spacing={4} alignItems="center" sx={{ py: 1 }}>
          <Typography sx={{ fontSize: "1.5rem", fontWeight: 500 }}>
            {t("please wait switching workstation mode")}
          </Typography>

          <CircularProgress size={60} />

          <Typography
            sx={{
              fontSize: "1.1rem",
              textAlign: "center"
            }}
          >
            {t("the system is preparing the port")}
          </Typography>
        </Stack>
      </DialogContent>
    </DialogRoot>
  );
}
